import { IOptionProps } from '@pnld/components-web'

/**
 * @description Function to convert string env to boolean
 * @param {string} [env] - The env to be converted.
 * @returns {boolean} A boolean value.
 */
export const stringToBoolean = (env?: string): boolean => {
  return env ? env.toLowerCase() === 'true' : false
}

/**
 * @description Function to convert a list of strings to select options
 * @param {string[]} list - The list of strings to be converted.
 * @returns {IOptionProps[]} An array of select options.
 */
export const stringListToOptions = (
  list: (string | number)[] | undefined
): IOptionProps[] => {
  if (!list || !Array.isArray(list)) {
    return []
  }

  return (list || []).map(item => ({
    label: String(item),
    value: String(item),
  }))
}
